import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { PostsFacade } from 'src/app/modules/posts/store';

import { IPostsCtx } from '../../../shared/components/posts/list/posts.component';
import {
  selectStatus,
  selectComments,
  selectCommentsStatus,
  selectCommentsCount,
  selectReplies
} from '../../../shared/ui/post/data/store/selector';
import {
  deletePost,
  likePost,
  complainePost,
  sharePost,
  updatePost,
  unpinPost,
  pinPost,
  paginatePostsByUser,
  addCommentToPost,
  deleteComment,
  likeComment,
  replyComment,
  loadCommentsForPost
} from '../../../shared/ui/post/data/store/actions';
import { IPost } from '../../../shared/models/post';
import { IMessage } from '../../../shared/components/message/message.component';
import { ICommentForm } from '../../../shared/models/comment';
import { SavedPostsFacade } from '../../../shared/stores/posts/saved/posts.saved.facade';

@Component({
  selector: 'app-organization-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss']
})
export class OrganizationPostsComponent implements OnInit {
  @Input() posts: any[];
  @Input() readonly orgId: number;

  public isMyProfile$: Observable<boolean>;
  readonly status$ = this.store.select(selectStatus());
  readonly isLoading$ = this.status$.pipe(
    map((status) => status === `LOADING`)
  );

  constructor(
    readonly store: Store,
    readonly savedPosts: SavedPostsFacade,
    private readonly postFacade: PostsFacade
  ) {}

  ngOnInit(): void {
    // this.isMyProfile$ = this.activatedRoute.params.pipe(
    //   filter(params => params.hasOwnProperty('id')),
    //   map(param => +param.id),
    //   map(profileUserId => profileUserId === this.auth.userID())
    // );
  }

  readonly postsCtx: IPostsCtx = {
    status: this.status$,
    delete: ({ id }) => this.store.dispatch(deletePost({ id })),
    like: ({ id }) => this.store.dispatch(likePost({ id })),
    complain: ({ id }) => this.store.dispatch(complainePost({ id })),
    share: ({ id }, message) => {
      this.postFacade.sharePost(id, message);
    },
    update: async (post, message) => {
      this.postFacade.updatePost(post.id, message);
    },
    pin: (post) => {
      if (post.pinned) {
        this.store.dispatch(unpinPost({ post }));
      } else {
        this.store.dispatch(pinPost({ post }));
      }
    },
    paginate: (_, page) => {
      // TODO: refactor orgId + ""
      this.store.dispatch(
        paginatePostsByUser({ id: this.orgId + '', nextPage: page })
      );
    },
    save: (post) => {
      this.savedPosts.toggleSave(post);
    },
    comments: {
      add: async (post, message) => {
        const form = await this.getCommentForm(post, message);
        this.store.dispatch(addCommentToPost({ comment: form }));
      },
      delete: (post, comment) => {
        this.store.dispatch(deleteComment({ comment }));
      },
      like: (post, comment) => {
        this.store.dispatch(likeComment({ comment }));
      },
      reply: async (post, comment, message) => {
        const form = await this.getCommentForm(post, message);
        form['comment_id'] = comment.id;
        this.store.dispatch(replyComment({ comment: form }));
      },
      get: (post) => {
        return {
          values: this.store.select(selectComments(post.id)),
          status: this.store.select(selectCommentsStatus(post.id)),
          count: this.store.select(selectCommentsCount(post.id))
        };
      },
      paginate: (post, comments) => {
        this.store.dispatch(
          loadCommentsForPost({ post, offset: comments.length })
        );
      },
      replies: {
        get: (_, comment) => {
          return this.store.select(selectReplies(comment.id));
        }
      }
    }
  };

  protected async getCommentForm(
    post: IPost,
    message: IMessage
  ): Promise<ICommentForm> {
    return {
      post_id: post.id,
      text: message.text,
      foto: message.images,
      file: message.docs,
      links: message.linksToPreview
      // comment_id: comment.id,
    };
  }
}
